import { i18n } from '@/locales';
const { t } = i18n;
export default {
    DEPOSIT: {
        text: t('views.baromoney.deposit'),
        value: '00',
    },
    WITHDRAWAL: {
        text: t('views.baromoney.withdraw'),
        value: '01',
    },
    CASH_REMITTANCE: {
        text: t('views.baromoney.cash_remittance'),
        value: 'X1',
    },
};
